import { PreferencesGetter } from '../types';

export enum GameKind {
    GoldenRace,
    NsoftVirtual,
    CasinoLive,
    CasinoGeneric,
    LiveDealer,
    BingoRoom,
}

export type RecentlyPlayedGame = {
    id: string;
    kind: GameKind;
} | {
    id: number;
    kind: 'lotto';
};

export interface GamingUserPreferencesState {
    recentlyPlayedGames: RecentlyPlayedGame[];
}

export interface GamingUserPreferencesStateLegacy {
    recentlyPlayedGames: RecentlyPlayedGame[];
}
export interface GamingGetters {
    recentlyPlayedGames: PreferencesGetter<string[]>;
    recentlyPlayedGamesHomepage: PreferencesGetter<RecentlyPlayedGame[]>;
}
